import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import { ShipmentWorkItemAccessorialsState } from "./ShipmentReconciliationState";
import ShipmentReconciliationService from "../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { ShipmentWorkItemAccessorialsRequest } from "../../app/data/shipment-reconciliation/models";

const initialState: ShipmentWorkItemAccessorialsState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  accessorials: []
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const shipmentWorkItemAccessorialsSlice = createSlice({
  name: "shipmentWorkItemAccessorialsSlice",
  initialState,
  reducers: {
    resetShipmentWorkItemAccessorialsState: (state) => initialState,
    shipmentWorkItemAccessorialsLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    shipmentWorkItemAccessorialsLoadingSucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
      state.accessorials = payload.accessorials;
    },
    shipmentWorkItemAccessorialsLoadingFailed: (state, { payload }) => {
      state.loading = false;
      state.loadingFailed = true;
    }
  },
});

export const {
  resetShipmentWorkItemAccessorialsState,
  shipmentWorkItemAccessorialsLoadingStarted,
  shipmentWorkItemAccessorialsLoadingSucceed,
  shipmentWorkItemAccessorialsLoadingFailed
} = shipmentWorkItemAccessorialsSlice.actions;

export const shipmentWorkItemAccessorialsSelector = (state: IState) => state.shipmentWorkItemAccessorials;

export const getShipmentWorkItemAccessorials = (
  shipmentWorkItemId: number,
  requestData: ShipmentWorkItemAccessorialsRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(shipmentWorkItemAccessorialsLoadingStarted());
  const response = await shipmentReconciliationService.getShipmentWorkItemAccessorialsList(shipmentWorkItemId, requestData);
  if (response.ok() && response.data) {
    dispatch(shipmentWorkItemAccessorialsLoadingSucceed(response.data));
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(shipmentWorkItemAccessorialsLoadingFailed(error));
    onError && onError(error)
  }
};

const shipmentWorkItemAccessorialsReducer = shipmentWorkItemAccessorialsSlice.reducer;
export default shipmentWorkItemAccessorialsReducer;